
import { Vue, Component, Prop } from "vue-property-decorator";
import { RequireKitResponse } from "@/models/entities/storage/cart/cartKit.interface";
import RequiredKit from "@/components/cart/RequiredKit.vue";
import { StorageElements } from "@/models/entities/storage/storageElements.interface";
@Component({
  components: {
    RequiredKit,
  },
})
export default class CartResume extends Vue {
  @Prop({ required: false, default: null }) private totalItems: number;
  @Prop({ required: false, default: null })
  private totalItemsWithoutTax: number;
  @Prop({ required: false, default: null }) private totalItemsWithTax: number;
  @Prop({ required: false, default: null }) private kit: RequireKitResponse;
  @Prop({ required: true }) private elementsList: StorageElements[];

  private notes = "";

  private orderConfirm(): void {
    this.$emit("orderConfirm", this.notes);
  }

  private changeKit(values: RequireKitResponse): void {
    this.$emit("changeKit", values);
  }
}
